import { Client_Environment_Config } from "./Client_Environment_Config_Type";

export const Client_Config_Preview: Client_Environment_Config = {
    paypal_client_id: 'AZQ_nI5L3GW_0GmZSs9xvgGkEuE_8ZmCG-wVWv0N9m6mT6M8DVFQWNx5t0Knc-GXW04QoCCQYlSgsyYQ',
}